<template>
    <div class="person-form">
        <h4>{{ personType }} {{ index }}</h4>
        <v-form ref="form">
            <v-layout row wrap class="mt-4 pa-2">
                <v-flex xs12 md5>
                    <label>Ad:</label>
                    <v-text-field type="text" v-model="person.Ad" :rules="[rules.required, rules.minLength(2)]"/>

                    <label>Soyad:</label>
                    <v-text-field type="text" v-model="person.Soyad" :rules="[rules.required, rules.minLength(2)]"/>

                    <label>TC Kimlik No:</label>
                    <v-text-field type="text" v-model="person.TcKimlikNo" :rules="[rules.required, rules.tcKimlik]"/>

                    <label>Adres:</label>
                    <v-textarea hide-details :label="$t('Address_label')" v-model="person.Adres"></v-textarea>

                </v-flex>
                <v-flex xs12 md5>
                    <label>Doğum Tarihi:</label>
                    <tarihcomp :etiket="$t('Date-of-Birth')" v-bind:detaygizle="true" v-bind:defaultvalue="'yes'"
                        v-bind:value="person.DogumTarihi" v-model="person.DogumTarihi" :rules="[rules.required]">
                    </tarihcomp>
                    <div class="mt-2">
                        <label>Cinsiyet:</label>
                        <v-select :items="cinsiyetler" v-model="person.Cinsiyet" hide-details item-text="text"
                            item-value="value" :rules="[rules.required]" >
                        </v-select>
                    </div>
                    <div class="mt-2">
                        <label>Telefon:</label>
                        <v-text-field type="text" v-model="person.Telefon" />
                    </div>
                    <label>Cep Telefonu:</label>
                    <v-text-field type="text" v-model="person.CepTelefonu" />

                    <label>Email:</label>
                    <v-text-field type="email" v-model="person.Email" />
                </v-flex>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
import tarihcomp from '../../customcomp/tarihim.vue'

export default {
    data() {
        return {
            cinsiyetler: [{
            text: "Erkek",
            value: 'E'
        },
        {
            text: "Kadın",
            value: 'K'
        }],
        rules: {
        required: value => !!value || "Bu alan zorunludur.",
        minLength: length => value => (value && value.length >= length) || `En az ${length} karakter giriniz.`,
        maxLength: length => value => (value && value.length <= length) || `En fazla ${length} karakter giriniz.`,
        email: value => /.+@.+\..+/.test(value) || "Geçerli bir e-posta adresi giriniz.",
        numeric: value => /^\d+$/.test(value) || "Sadece rakam giriniz.",
        tcKimlik: value =>
          value.length === 11 && /^\d+$/.test(value) || "Geçerli bir TC Kimlik No giriniz (11 haneli).",
        phone: value =>
          (value && value.length === 10 && /^\d+$/.test(value)) || "Geçerli bir telefon numarası giriniz (10 haneli).",
      },
        }
    },
    props: {
        person: {
            type: Object,
            required: true,
        },
        personType: {
            type: String,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        odaId:{
            type:Number,
            required:true
        },

    },
    watch: {
    person: {
        handler(newVal, oldVal) {
            this.validateForm();
        },
            deep: true,
        },
    },
    components: {
        tarihcomp
    },
    methods:{
        validateForm() {
            // Formun validasyon durumunu kontrol et
            const isValid = this.$refs.form.validate();
            // Parent'a id ve validasyon sonucunu gönder
            this.$emit("form-valid", { odaId : this.odaId, kisiTip:this.person.KisiTip,id: this.person.id, isValid });
        },
    }
};
</script>

<style scoped>
.person-form {
    margin-bottom: 15px;
    padding: 10px;
    border: 1px dashed #aaa;
    border-radius: 5px;
}
</style>